import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

import { UserService } from '@core/services/user.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  status: boolean;
  subscription: Subscription;
  name$: string= "";
  isLoggedIn$: Observable<boolean>;
  userLogado
  perfilAndUserLogado

  isSAC = false;

  constructor(private userService: UserService, 
              private breakpointObserver: BreakpointObserver) {
  }

  logout() {
    this.userService.logout();
  }

  isMobileView = false; // Variável para controlar a exibição do menu móvel

  // Verifica a largura da tela ao inicializar o componente e em mudanças de redimensionamento
  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   this.checkScreenWidth();
  // }

  // // Método para verificar a largura da tela e definir a variável isMobileView
  // checkScreenWidth() {
  //   this.isMobileView = window.innerWidth <= 1000; // Defina o limite de largura para dispositivos móveis
  // }

  ngOnInit() {

    this.isLoggedIn$ = this.userService.authNavStatus();
    this.subscription = this.userService.authNavStatus$
                            .subscribe(status => { this.status = status; this.loadUserName() },
                                       fail =>   { this.userService.logout() });

    this.breakpointObserver.observe([
    Breakpoints.Handset
    ]).subscribe(result => {
    this.isMobileView = result.matches;
    });

  }

  loadUserName(){
    if(this.status){
      this.userLogado = JSON.parse(localStorage.getItem("user_logado"));
      //this.userService.profile().subscribe(res=>{this.name$=res.firstName;})
    }

    this.verifySac();
    
  }

  verifySac(){
    if(this.status){
      this.perfilAndUserLogado = JSON.parse(localStorage.getItem("user_logado"));
      if(this.perfilAndUserLogado.perfil == 3){
        this.isSAC = true;
      }
    }
  }

  ngOnDestroy() {
    // prevent memory leak when component is destroyed
    this.subscription.unsubscribe();
  }
}
